import { mapToCompanyInfoList } from 'helpers/mapToCompanyInfoList';
import { ICompanyDetails } from '../../../models';
import { IClient, IClientListInfoItem } from '../models';

export function mapCompanyDetails(
	data: IClient,
	titles: IClientListInfoItem[],
): ICompanyDetails {
	const {
		formalName,
		logoUrl,
		locationCount,
		domainCount,
		employeesCount,
		officeCount,
		shortName,
		contractStartDate,
		contractEndDate,
		contractUrl,
		surveyCount,
		surveyCountLimit,
		domainName,
		website,
	} = data;

	return {
		logoUrl,
		shortName,
		formalName,
		// TODO add adapter mapContractData
		contractData: {
			startDate: contractStartDate,
			endDate: contractEndDate,
			fileUrl: contractUrl,
			fileKey: '',
		},
		domain: domainName || '',
		companyURL: website || '',
		infoList: mapToCompanyInfoList(
			{
				locationCount,
				domainCount,
				employeesCount,
				officeCount,
			},
			titles,
		),
		sent: surveyCount,
		allowedLimit: surveyCountLimit,
	};
}
